import React from 'react';
import { getOne, deleteOne } from 'api/facilityDeviceApi';
import Message from 'rc-message';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import moment from 'moment';
import Permissions from 'react-redux-permissions';

// import * as _ from 'lodash';
import DisplayField from 'components/elements/display-field';
import Clearfix from 'components/elements/clearfix';
import Confirm from 'components/elements/confirm-element';
import slug from 'constants/slug';
import { COLOR, DATETIME_FORMAT, DATE_FORMAT } from 'config';
import AttachmentContainer from 'containers/AttachmentContainer';
import {
  getList as getFacAttachList,
  deleteOne as deleteAttach,
  create as createFacAttach,
} from 'api/deviceAttachmentApi';
import { getLookupTypeDeviceAttachment } from 'api/lookuplistitemApi';
import PageLockHOC from 'hoc/pageLock';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

@PageLockHOC(['facilityDevice.view'])
@connect(
  (state) => ({
    menuSelected_2: state.menu.menuSelected_2,
    focusFacility: state.menu.focusFacility,
  }),
  {}
)
class FacilitypermitView extends React.Component {
  state = {
    _idObject: '',
    isLoaded: false,
    isLoading: false,
    facility: {},
    facilityId: '',
    initialValue: null,
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) {
      return '';
    }

    switch (type) {
      case 'date':
      case 'date_1':
        return moment(value).format(
          type === 'date_1' ? DATETIME_FORMAT : DATE_FORMAT
        );
      case 'dates':
        return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
          value[1]
        ).format(DATE_FORMAT)}`;
      default:
        return value;
    }
  };

  getInitialDateValue = (keyPath, isDate, defaultValue = '') => {
    let value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) return '';
    if (isDate) return moment(value).format(DATE_FORMAT);
    return moment(value).format(DATETIME_FORMAT);
  };

  async checkValidate() {
    const _id = _.result(this.props, 'match.params._id');

    if (_id) {
      const res = await getOne(_id);

      if (res.success && res.data) {
        this.setState({
          _idObject: res.data._id,
          facility: res.data.facility,
          facilityId: res.data.facility._id,
          isLoading: false,
          isLoaded: true,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.FACILITY_DEVICE.LIST);
    }
  }

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const DeviceName = this.getInitialValue('Name');

      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xoá thiết bị: `} <b> {DeviceName}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              if (this.props.menuSelected_2) {
                this.props.history.push(
                  `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                );
              } else {
                this.props.history.push(slug.FACILITY_DEVICE.LIST);
              }
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  convertDataBoolean = (keyPath, defaultValue = false) => {
    const { initialValue } = this.state;

    const value = _.result(initialValue, keyPath, defaultValue);

    return value ? (
      <img height={14} alt='check-icon' src='/icons/badge-check.png' />
    ) : (
      ''
    );
  };

  async componentWillMount() {
    await this.checkValidate();
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />

        <h4 className='bp3-heading' style={{ color: COLOR.SUCCESS }}>
          Chi tiết thiết bị
        </h4>

        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Icon
              onClick={() => {
                if (this.props.menuSelected_2) {
                  this.props.history.push(
                    `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                  );
                } else {
                  this.props.history.push(slug.FACILITY_DEVICE.LIST);
                }
              }}
              style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
              icon={IconNames.CIRCLE_ARROW_LEFT}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.SUCCESS}
            />

            {this.props.focusFacility && (
              <React.Fragment>
                <Permissions allowed={[`facilityDevice.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={
                        slug.FACILITY_DEVICE.EDIT_WITH_ID + this.state._idObject
                      }
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>

                <Permissions allowed={[`facilityDevice.delete`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.BAN_CIRCLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.handelDelete}
                    />
                  </React.Fragment>
                </Permissions>
              </React.Fragment>
            )}
          </div>
        </HeaderContainer>

        <Clearfix height={16} />

        <DisplayField
          isRequiredField
          label='Tên thiết bị'
          value={this.getInitialValue('Name')}
        />

        <Clearfix height={16} />

        <DisplayField
          label='Tình trạng'
          value={this.getInitialValue('Status')}
        />

        <Clearfix height={16} />

        <DisplayField label='Vị trí' value={this.getInitialValue('Location')} />

        <Clearfix height={16} />

        <DisplayField
          label='Thông số kĩ thuật'
          value={this.getInitialValue('TechnicalSpec')}
        />

        <Clearfix height={16} />

        <DisplayField
          label='Năm sản xuất'
          value={this.getInitialValue('ProductionDate')}
        />
        <Clearfix height={16} />

        <DisplayField
          label='Catalog/ data sheet'
          value={this.convertDataBoolean('IsCatalog')}
        />

        <Clearfix height={16} />

        <DisplayField label='CO' value={this.convertDataBoolean('IsCO')} />

        <Clearfix height={16} />

        <DisplayField label='CQ' value={this.convertDataBoolean('IsCQ')} />

        <Clearfix height={16} />

        <DisplayField
          label='Bảo trì bảo dưỡng gần nhất'
          value={this.getInitialDateValue('LatestMaintenanceDate', true)}
        />

        <Clearfix height={16} />

        <DisplayField
          label='Sửa chữa gần nhất'
          value={this.getInitialDateValue('LatestRepairDate', true)}
        />

        <Clearfix height={16} />

        <DisplayField
          label='Hiệu chuẩn gần nhất'
          value={this.getInitialDateValue('LatestCalibrationDate', true)}
        />

        <Clearfix height={16} />

        <DisplayField
          label='Kiểm định gần nhất'
          value={this.getInitialDateValue('LatestVerificationDate', true)}
        />

        <Clearfix height={16} />

        <DisplayField
          label='Thêm vào'
          value={
            this.getInitialDateValue('AddedOn') +
            ' bởi ' +
            this.getInitialValue('AddedBy')
          }
        />
        <Clearfix height={16} />

        <DisplayField
          label='Cập nhật lần cuối'
          value={`${this.getInitialValue('UpdatedOn', '', 'date_1')}${
            this.getInitialValue('UpdatedBy', '')
              ? ` bởi ${this.getInitialValue('UpdatedBy', '')}`
              : ''
          }`}
        />

        <Clearfix height={8} />

        {this.state.isLoaded && (
          <AttachmentContainer
            hideButtonAction={this.props.focusFacility ? false : true}
            facility={this.state.initialValue}
            getListFunc={(query) => {
              return getFacAttachList({
                ...query,
                facilityDevice: this.state._idObject,
              });
            }}
            createOne={(values) => {
              values.facilityDevice = this.state._idObject;
              return createFacAttach(_.pickBy(values, _.identity));
            }}
            deleteOne={deleteAttach}
            getAttachmentTypeList={getLookupTypeDeviceAttachment}
            moduleName='facilityDevice'
          />
        )}
      </div>
    );
  }
}

export default withRouter(FacilitypermitView);



// WEBPACK FOOTER //
// ./src/containers/FacilityDeviceContainer/FacilityDeviceView/index.js